import type { z } from 'zod'

import { isValidPhoneNumber } from '@/legacy-src/lib/libphonenumber/isValidPhoneNumber'

export function phone(schema: z.ZodString, message?: string): z.ZodEffects<z.ZodString>
export function phone(schema: z.ZodOptional<z.ZodString>, message?: string): z.ZodEffects<z.ZodOptional<z.ZodString>>
export function phone(
  schema: z.ZodOptional<z.ZodString> | z.ZodString,
  message?: string,
): z.ZodEffects<z.ZodString> | z.ZodEffects<z.ZodOptional<z.ZodString>> {
  return schema.refine((value) => {
    if (value) {
      return isValidPhoneNumber(value)
    }

    return true
  }, message)
}
